import { useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Card, Row, Tag, Typography } from 'antd';
import cn from 'classnames';
import type { User } from 'models/user';
import { useAppSelector } from 'services/redux/configureStore';

import styles from './AssignedUsers.module.css';
import { ChangeAssignedModal } from './ChangeAssignedModal/ChangeAssignedModal';

interface Props {
  id: User['id'];
  assignedUsers: User['assignedUsers'];
}

export const AssignedUsers = ({ id, assignedUsers }: Props) => {
  const [isEditing, setIsEditing] = useState(false);

  const isDarkMode = useAppSelector((state) => state.theme.isDarkMode);

  return (
    <>
      <Card
        className={cn(styles.card, { [styles.dark]: isDarkMode })}
        bordered={false}
        title={
          <Row justify="space-between">
            <Typography.Title level={5}>Доступные пользователи</Typography.Title>
            <Button icon={<EditOutlined />} onClick={() => setIsEditing(true)} />
          </Row>
        }
      >
        {Boolean(assignedUsers?.length) &&
          assignedUsers?.map((au) => (
            <Tag key={au.id} style={{ marginBottom: 4 }}>
              {au.name}
            </Tag>
          ))}
        {assignedUsers?.length === 0 && (
          <Typography.Text type={'secondary'}>Нет доступных пользователей</Typography.Text>
        )}
      </Card>

      <ChangeAssignedModal
        open={isEditing}
        onCancel={() => setIsEditing(false)}
        id={id}
        assignedUsers={assignedUsers}
      />
    </>
  );
};
